import ReactDOM from 'react-dom/client';
import App from './App';
// localization
import i18n from './i18n';

// styles
import 'antd/dist/reset.css';
import 'resources/fonts/fonts.css';
import 'resources/styles/index.scss';
import { I18nextProvider } from 'react-i18next';

import MainLoader from './components/loaders/main-loader';
import { BrowserRouter } from 'react-router';
import { StrictMode, Suspense } from 'react';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<MainLoader className='suspense' isLoading />}>
          <App />
        </Suspense>
      </I18nextProvider>
    </BrowserRouter>
  </StrictMode>,
);
